import { StaticImage } from 'gatsby-plugin-image';
import { Wrapper } from '../Header';
import * as styles from './index.module.less';
import React from 'react';

interface Props {
  isMediaTool: boolean;
}
export const FooterBanner = ({ isMediaTool }: Props) => {
  const LinkWrapper = Wrapper(isMediaTool);

  return (
    <div className={styles.footer_banner__container}>
      <div className={styles.footer_banner__content}>
        <div className={styles.content_left}>
          <p className="caption-new left-aligned footer">
            🍀 &nbsp;NottaはDX推進・ペーパーレス化に応援します。取材、プレスリリース、レビュー等に関するお問い合わせ:
            <a href="mailto:contact@notta.ai" className="link-new footer">
              contact@notta.ai
            </a>
          </p>
          <p>
            <LinkWrapper to="/terms" target="_blank" className="link-new footer">
              利用規約
            </LinkWrapper>
            ｜
            <LinkWrapper to="/privacy" target="_blank" className="link-new footer">
              プライバシー
            </LinkWrapper>
            ｜
            <LinkWrapper to="/sitemap" target="_blank" className="link-new footer">
              サイトマップ
            </LinkWrapper>
            ｜
            <LinkWrapper to="/share-jp" target="_blank" className="link-new footer">
              友達紹介キャンペーン利用規約
            </LinkWrapper>
            ｜
            <LinkWrapper to="/security" target="_blank" className="link-new footer">
              セキュリティシステム
            </LinkWrapper>
            <br />
          </p>
        </div>
        <div className={styles.content_right}>
          <div className={styles.button_container}>
            <a
              id="footer_appstore_icon"
              href="https://apps.apple.com/app/id1480649572"
              target="_blank"
              // className="link-block-new badge w-inline-block"
              rel="noreferrer"
            >
              <StaticImage
                src="../../../images/btn-appstore-jp2x.png"
                loading="lazy"
                alt="App Storeからダウンロード"
                style={{ width: '162px' }}
              />
            </a>
            <a
              id="footer_googleplay_icon"
              href="https://play.google.com/store/apps/details?id=com.langogo.transcribe"
              // className="link-block-new badge w-inline-block"
            >
              <StaticImage
                src="../../../images/btn-google-play-jp2x.png"
                loading="lazy"
                alt="Google Playで手に入れよう"
                style={{ width: '162px' }}
              />
            </a>
          </div>
          <div className={styles.footer_star_container}>
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <p>200万ダウンロード突破！</p>
          </div>
        </div>
      </div>
      <div className={styles.copyright_info}>Copyright © 2024 Notta. All Rights Reserved.</div>
    </div>
  );
};
